import React from 'react';
import { observer } from 'mobx-react';
import { GridInputCellTemplate } from 'themes/components';

@observer
class GridInputCell extends React.Component {
    render() {
        return (
            <GridInputCellTemplate {...this.props}/>
        );
    }
}

export default GridInputCell;